import React, { useContext, useState, useEffect } from "react";
import { Layout, Menu, Typography, Drawer, Button } from "antd";
import {
  HomeOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  TeamOutlined,
  UploadOutlined,
  ClockCircleOutlined,
  LoginOutlined,
  ScanOutlined,
  SafetyOutlined,
  BankOutlined,
  SolutionOutlined,
  ApartmentOutlined,
  FormOutlined,
  FileProtectOutlined,
  DollarOutlined,
  FileTextOutlined,
  CalendarOutlined,
  FileDoneOutlined,
  ProfileOutlined,
  ScheduleOutlined,
  LogoutOutlined,
  UserDeleteOutlined,
  AuditOutlined,
  EnvironmentOutlined,
  CalendarTwoTone,
  BarChartOutlined,
  FileExcelOutlined,
  PieChartOutlined,
  RiseOutlined,
  PlusSquareOutlined,
  ThunderboltOutlined,
  ReadOutlined,
  MenuOutlined,
  ExportOutlined,
  AlertOutlined
} from "@ant-design/icons";
import DashboardHeader from "../../../components/dashboardheader/DashboardHeader";
import Footer from "../../../components/footer/Footer";
import { AuthContext } from "../../../context/AuthContext";
import HrArea from "../../announcement/hrarea/HrArea";
// import ViewEmpArticle from "../viewemparticle/ViewEmpArticle";
import HrVerifiedCandidates from "../HrVerifiedCandidates";
import AddHoliday from "../AddHoliday";
import ViewHoliday from "../ViewHoliday";
import ViewEmployees from "../../ViewEmployees";
import HrViewAnnouncement from "../../hr/hrviewannouncement/HrViewAnnouncement";
import SalaryStatement from "../../../components/payroll/SalaryStatement";
import ActualSalaryStatement from "../ActualSalaryStatement";
import FinalSalaryStatement from "../FinalSalaryStatement";
import AddAppraisal from "../AddAppraisal";
import TriggerAppraisal from "../TriggerAppraisal";
import ShowOneAssessment from "../../ShowOneAssessment"
import TeamAssessment from "../../TeamAssessment";
import FinalSettlement from "../FinalSettlement";
import HrIndex from "../../hr/HrIndex"
import EmployeeAttendanceReport from "../../../components/HrReports/EmployeeAttendanceReport";
import LeaveUtilizationReport from "../../../components/HrReports/LeaveUtilizationReport";
import FullSettlement from "../FullSettlement";
import FixedSalary from "../../hr/FixedSalary";
import BulkEmpUpload from "../BulkEmpUpload";
import OtApprovals from "../../../components/OtApprovals";
import ViewMrfPage from "../../onboarding/viewmrfpage/ViewMrfPage";
import InterviewAssessment from "../../onboarding/interview/InterviewAssessment";
import AddVenue from "../../onboarding/AddVenue";
import SignatureUpdation from "../SignatureUpdation";
import MakeSpecialPermission from "../../MakeSpecialPermission";
import SendMail from "../../../components/SendMail";
import NewEmployees from "../../NewEmployees";
import ViewEmployeeAttendance from "../../hr/ViewEmployeeAttendance";
import FingerHeadOffice from "../../hr/FingerPrintHead";
import AttendanceHead from "../../hr/AttendanceHead";
import FingerPrintSite from "../../hr/FingerPrintSite";
import AttendanceSite from "../../hr/AttendanceSite";
import OverallOT from "../../../components/hr/OverallOT";
import ShowSpecialPermission from "../../ShowSpecialPermission";
import PermissionRequests from "../../hr/PermissionRequests";
import TechnicalIssue from "../TechincalIssue";
import EmpLeaves from "../../hr/EmpLeaves";
import EmpPermissions from "../../hr/EmpPermissions";
import EmpCompoff from "../../hr/EmpCompoff";
import MyStatusRequests from "../MyStatusRequests";
import ImproperAttendance from "../ImproperAttendance";
import ViewImproper from "../ViewImproper";

const { Sider, Content } = Layout;
const { Title } = Typography;

export default function PayrollHr() {
  const { authData } = useContext(AuthContext);

  const [selectedMenu, setSelectedMenu] = useState(() => {
    return localStorage.getItem("payrollHrPage") || "home";
  });

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    localStorage.setItem("payrollHrPage", selectedMenu);
  }, [selectedMenu]);

  // MENU ITEMS
  const menuItems = [
    { key: "home", icon: <HomeOutlined />, label: "Dashboard" },

    {
      key: "employee",
      icon: <UsergroupAddOutlined />,
      label: "Employee Management",
      children: [
        { key: "showCandidates", icon: <UserSwitchOutlined />, label: "Convert Employee" },
        { key: "viewEmployees", icon: <TeamOutlined />, label: "View Employees" },
        { key: "empbulkupload", icon: <UploadOutlined />, label: "Employee Bulk Upload" },
      ],
    },

    {
      key: "attendance",
      icon: <ClockCircleOutlined />,
      label: "Attendance",
      children: [
        { key: "viewEmployeeRecords", icon: <LoginOutlined />, label: "Check-In & Check-Out" },
        { key: "fingerHeadOffice", icon: <ScanOutlined />, label: "Fingerprint – Head Office" },
        { key: "attendanceHeadOffice", icon: <BankOutlined />, label: "Attendance – Head Office" },
        { key: "fingerSiteOffice", icon: <SafetyOutlined />, label: "Fingerprint – Site Office" },
        { key: "attendanceSiteOffice", icon: <HomeOutlined />, label: "Attendance – Site Office" },
        { key: "otapproval", icon: <SolutionOutlined />, label: "OT Approvals" },
        {
          key: "generalpermission",
          icon: <ApartmentOutlined />,
          label: "General Permisssion",
          children: [
            { key: "special_permission", icon: <FormOutlined />, label: "Add General Permisssion" },
            { key: "show_special_permission", icon: <FormOutlined />, label: "Show General Permisssion" },
            { key: "raise_technical_issue", icon: <FormOutlined />, label: "Rasie Technical Issue" },
          ],
        },
        {
          key: "improperAttendance",
          icon: <SolutionOutlined />,
          label: "Inproper Attendance",
          children: [
            { key: "improper", icon: <FormOutlined />, label: "Add Inproper Attendance" },
            { key: "viewImproper", icon: <FormOutlined />, label: "View Inproper Attendance" },

          ],
        },
        // { key: "empot", icon: <FileProtectOutlined />, label: "Request For Considerations" },
      ],
    },

    {
      key: "payroll",
      icon: <DollarOutlined />,
      label: "Payroll",
      children: [
        { key: "viewsalary", icon: <FileTextOutlined />, label: "Actual Salary" },
        { key: "actualsalary", icon: <CalendarOutlined />, label: "Monthly Salary Statement (month)" },
        { key: "Finalsalary", icon: <FileDoneOutlined />, label: "Final Salary Statement (month)" },
      ],
    },

    {
      key: "leaves",
      icon: <CalendarOutlined />,
      label: "Leaves & Permissions",
      children: [
        { key: "empleaves", icon: <FileDoneOutlined />, label: "Leaves" },
        { key: "emppermissions", icon: <ExportOutlined />, label: "Permissions" },
        { key: "empcompoffs", icon: <AlertOutlined />, label: "Off Day Working" },
      ],
    },

    {
      key: "requirtment",
      icon: <ProfileOutlined />,
      label: "Recruitement",
      children: [
        { key: "job_openings", icon: <FileTextOutlined />, label: "Job Openings" },
        { key: "interview", icon: <ScheduleOutlined />, label: "Schedule Interview" },
      ],
    },

    {
      key: "Exit Management",
      icon: <LogoutOutlined />,
      label: "Exit Management",
      children: [
        { key: "resignedEmployees", icon: <UserDeleteOutlined />, label: "Resigned Employees" },
        { key: "fullsettlement", icon: <AuditOutlined />, label: "Full & Final settlement" },
        // { key: "finalsettlements", icon: <FileDoneOutlined />, label: "Final Settlement" },
      ],
    },

    { key: "addVenue", icon: <EnvironmentOutlined />, label: "Add Venue" },

    {
      key: "holidays",
      icon: <CalendarTwoTone />,
      label: "Holiday List",
      children: [
        { key: "addHolidays", icon: <PlusSquareOutlined />, label: "Add Holidays" },
        { key: "editHolidays", icon: <ReadOutlined />, label: "View Holidays" },
      ],
    },

    {
      key: "reports",
      icon: <BarChartOutlined />,
      label: "Reports",
      children: [
        { key: "employeeattendance", icon: <FileExcelOutlined />, label: "Employee Attendance Report" },
        { key: "leaveutilization", icon: <PieChartOutlined />, label: "Leave Utilization Report" },
      ],
    },

    {
      key: "appraisal",
      icon: <RiseOutlined />,
      label: "Appraisal",
      children: [
        { key: "addAppraisal", icon: <PlusSquareOutlined />, label: "Add Appraisal" },
        { key: "startAppraisal", icon: <ThunderboltOutlined />, label: "Trigger Appraisal" },
        { key: "viewAppraisals", icon: <ReadOutlined />, label: "View Appraisal Assessments" },
      ],
    },
    { key: "statusApprovals", icon: <FormOutlined />, label: "Status Requests" },

  ];


  // PAGE RENDERING
  const renderContent = () => {
    switch (selectedMenu) {
      case "home":
        return (
          <>
            {/* <Title level={2}>
              Welcome {authData?.employee?.first_name || "Payroll HR"}!
            </Title> */}
            {/* <p>This is your Payroll HR dashboard.</p> */}
            <HrIndex />
          </>
        );
      case "makeAnnouncement":
        return <HrArea />;
      case "viewAnnouncement":
        return <HrViewAnnouncement />;
      case "showCandidates":
        return <HrVerifiedCandidates />;
      case "addHolidays":
        return <AddHoliday />;
      case "editHolidays":
        return <ViewHoliday />;
      case "viewEmployees":
        return <ViewEmployees />;
      case "fullsettlement":
        return <FullSettlement />
      case "salarydetails":
        return <SalaryStatement />
      case "actualsalary":
        return <ActualSalaryStatement />;
      case "Finalsalary":
        return <FinalSalaryStatement />;
      case "addAppraisal":
        return <AddAppraisal />
      case "startAppraisal":
        return <TriggerAppraisal />
      case "viewAppraisals":
        return <TeamAssessment />
      case "finalsettlements":
        return <FinalSettlement />
      case "employeeattendance":
        return <EmployeeAttendanceReport />
      case "leaveutilization":
        return <LeaveUtilizationReport />
      case "viewsalary":
        return <FixedSalary />
      case "empbulkupload":
        return <BulkEmpUpload />
      case "otapproval":
        return <OtApprovals />
      case "job_openings":
        return <ViewMrfPage />;
      case "interview":
        return <InterviewAssessment />;
      case "addVenue":
        return <AddVenue />;
      case "signatureUpdation":
        return <SignatureUpdation />
      case "special_permission":
        return <MakeSpecialPermission />
      case "show_special_permission":
        return <PermissionRequests />
      case "sendmail":
        return <NewEmployees />
      case "resignedEmployees":
        return <ViewEmployees isResigned={true} />;
      case "viewEmployeeRecords":
        return <ViewEmployeeAttendance />;
      case "fingerHeadOffice":
        return <FingerHeadOffice />;
      case "attendanceHeadOffice":
        return <AttendanceHead />;
      case "fingerSiteOffice":
        return <FingerPrintSite />;
      case "attendanceSiteOffice":
        return <AttendanceSite />;
      case "empot":
        return <OverallOT />
      case "raise_technical_issue":
        return <TechnicalIssue />
      case "empleaves":
        return <EmpLeaves />
      case "emppermissions":
        return <EmpPermissions />
      case "empcompoffs":
        return <EmpCompoff />
      case "statusApprovals":
        return <MyStatusRequests />
      case "improper":
        return <ImproperAttendance />
      case "viewImproper":
        return <ViewImproper />
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      <DashboardHeader />
      {/* Mobile Header with Drawer Trigger */}
      {isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "10px 20px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px", color: "#0e497b" }} />}
            onClick={() => setDrawerVisible(true)}
          />
        </div>
      )}

      <Layout style={{ background: "#fff" }}>
        {/* DESKTOP SIDEBAR */}
        {!isMobile && (
          <Sider
            width={280}
            collapsible
            collapsed={collapsed}
            onCollapse={(val) => setCollapsed(val)}
            theme="light"
            style={{
              background: "#fff",
              borderRight: "1px solid #f0f0f0",
              boxShadow: "2px 0 6px rgba(0,0,0,0.05)",
            }}
          >
            <style>
              {`
              .ant-menu {
                background: #fff !important;
                border-right: none !important;
              }

              .ant-menu-item,
              .ant-menu-submenu-title {
                font-weight: bold;
                color: #0e497b !important;
                transition: all 0.2s ease;
              }

              .ant-menu-item:hover,
              .ant-menu-submenu-title:hover {
                background-color: rgba(14, 73, 123, 0.05) !important;
                color: #0e497b !important;
              }

              .ant-menu-item-selected {
                background-color: #0e497b !important;
                color: #fff !important;
              }

              .ant-menu-item-selected .anticon {
                color: #fff !important;
              }

              .ant-menu-submenu-open > .ant-menu-submenu-title {
                color: #0e497b !important;
                background-color: rgba(14, 73, 123, 0.05) !important;
              }

              .ant-menu-submenu-arrow::before,
              .ant-menu-submenu-arrow::after {
                background-color: #0e497b !important;
              }
            `}
            </style>

            <Menu
              mode="inline"
              selectedKeys={[selectedMenu]}
              onClick={({ key }) => setSelectedMenu(key)}
              style={{
                height: "100%",
                borderRight: 0,
                background: "#fff",
                fontWeight: "bold",
              }}
              items={menuItems}
            />
          </Sider>
        )}

        {/* MOBILE DRAWER SIDEBAR */}
        <Drawer
          title="Menu"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
          footer={null}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedMenu]}
            onClick={({ key }) => {
              setSelectedMenu(key);
              setDrawerVisible(false);
            }}
            style={{
              height: "100%",
              borderRight: 0,
              background: "#fff",
              fontWeight: "bold",
            }}
            items={menuItems}
          />
        </Drawer>

        {/* MAIN CONTENT */}
        <Layout style={{ padding: isMobile ? "10px" : "24px", background: "#fff" }}>
          <Content style={{ background: "#fff" }}>{renderContent()}</Content>
        </Layout>
      </Layout>

      <Footer style={{ background: "#fff" }} />
    </Layout>
  );
}
